import { FieldProps } from 'formik';
import React from 'react';

import Checkbox from '@material-ui/core/Checkbox';

const CheckboxWrapper: React.FunctionComponent<FieldProps> = ({
    field,
    form,
    ...props
}) => (
    <Checkbox
        checked={field.value ? true : false}
        {...field}
        {...props}
        value={field.name}
        disableRipple={true}
        color="primary"
    />
);

export default CheckboxWrapper;
